import React from "react"
import propTypes from "prop-types"
import "./styles.scss"

import AccordionItem from "./components/Item"
import AccordionHeader from "./components/Header"
import AccordionContent from "./components/Content"

const Accordion = ({ children, className }) => {
  return <div className={`accordion ${className}`}>{children}</div>
}

Accordion.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]),
  className: propTypes.string
}

Accordion.defaultProps = {
  className: "",
  children: ""
}

export { AccordionItem, AccordionHeader, AccordionContent }

export default Accordion
